import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ApiService } from './core/services/api-mock.service';
import { GlobalsService } from './core/services/globals.service';
import { SharedAPIService } from './core/services/shared-api.service';
import { SharedComponentsModule } from './core/shared-components.module';
import { FnaModule } from './module/fna/fna.module';
import { GeneralModule } from './module/general/general.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http'
import { AppHttpInterceptor } from './core/services/http-interceptor.service';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    SharedComponentsModule,
    GeneralModule,
    FnaModule,
    NgbModule,
    AppRoutingModule,
    HttpClientModule
  ],
  providers: [ApiService, GlobalsService, SharedAPIService,{provide: HTTP_INTERCEPTORS,useClass: AppHttpInterceptor,multi: true}],
  bootstrap: [AppComponent],
})
export class AppModule {}
